export const SendOTPAPI = async (phone) => {
    try {

        const response = await fetch(`${process.env.REACT_APP_BASE_URL}send-otp`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                phone: phone,
            })
        });

        if (!response.ok) {
            console.error(`Failed to send mail, status: ${response.status}`);
            return null;
        }

        // Attempt to parse JSON response
        const data = await response.json();

        return data;


    } catch (error) {
        console.error("Error sending mail:", error);
        return null;
    }
};
